// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2cKCB","bigColWidth":"Table_bigColWidth__32HMA","biggerColWidth":"Table_biggerColWidth__1-DYN","row":"Table_row__1zGni","col":"Table_col__V1553"};